import React from 'react';
import { useLanguage } from '../LanguageContext';
import './LanguageToggle.css';

const LANGUAGES = [
  { code: 'sl', label: 'SL', aria: 'Slovenščina' },
  { code: 'en', label: 'EN', aria: 'English' },
];

function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-toggle" role="group" aria-label="Language">
      {LANGUAGES.map(({ code, label, aria }) => (
        <button
          key={code}
          type="button"
          className={`language-toggle-btn ${language === code ? 'active' : ''}`}
          onClick={() => setLanguage(code)}
          aria-label={aria}
          aria-pressed={language === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageToggle;
